import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_edit_address",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "fs-7 fw-bold text-gray-400 mt-1" }
const _hoisted_21 = { class: "col-md-12 section-block mt-3" }
const _hoisted_22 = { class: "d-flex flex-stack" }
const _hoisted_23 = { class: "me-5" }
const _hoisted_24 = { class: "fs-5 fw-bold" }
const _hoisted_25 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_26 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_27 = { class: "col-md-12 section-block mt-6" }
const _hoisted_28 = { class: "d-flex flex-stack" }
const _hoisted_29 = { class: "me-5" }
const _hoisted_30 = { class: "fs-5 fw-bold" }
const _hoisted_31 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_32 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_33 = { class: "modal-footer flex-center" }
const _hoisted_34 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_35 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_vue_google_autocomplete = _resolveComponent("vue-google-autocomplete")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_InnerLoader, {
        loading: _ctx.loading,
        innerLoading: true
      }, null, 8, ["loading"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_form, {
            model: _ctx.address,
            ref: "editAddressForm"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.EDIT')} ${_ctx.$t('message.ADDRESS')}`), 1),
                _hoisted_5
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "name",
                        label: _ctx.$t('message.NAME'),
                        required: true,
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.NAME')}`,
                        requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => (_ctx.address.name = $event)),
                        target: "name",
                        value: _ctx.address.name
                      }, null, 8, ["label", "placeholder", "requiredMsg", "name", "value"])
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "company",
                        label: `${_ctx.$t('message.COMPANY')} ${_ctx.$t('message.NAME')}`,
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.COMPANY')} ${_ctx.$t('message.NAME')}`,
                        requiredMsg: ` ${_ctx.$t('message.COMPANY')} ${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        company: _ctx.address.company,
                        "onUpdate:company": _cache[2] || (_cache[2] = ($event: any) => (_ctx.address.company = $event)),
                        target: "company",
                        value: _ctx.address.company
                      }, null, 8, ["label", "placeholder", "requiredMsg", "company", "value"])
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_Select, {
                        name: "country_id",
                        target: "country_id",
                        label: _ctx.$t('message.COUNTRIES'),
                        required: true,
                        filterable: true,
                        placeholder: _ctx.$t('message.SELECT'),
                        country_id: _ctx.address.country_id,
                        "onUpdate:country_id": _cache[3] || (_cache[3] = ($event: any) => (_ctx.address.country_id = $event)),
                        selectData: _ctx.countries,
                        value: _ctx.address.country_id
                      }, null, 8, ["label", "placeholder", "country_id", "selectData", "value"])
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "phone_number",
                        label: _ctx.$t('message.PHONE_NUMBER'),
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PHONE_NUMBER')}`,
                        requiredMsg: `${_ctx.$t('message.PHONE_NUMBER')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        phone_number: _ctx.address.phone_number,
                        "onUpdate:phone_number": _cache[4] || (_cache[4] = ($event: any) => (_ctx.address.phone_number = $event)),
                        target: "phone_number",
                        value: _ctx.address.phone_number
                      }, null, 8, ["label", "placeholder", "requiredMsg", "phone_number", "value"])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('message.ADDRESS')) + " 1 ", 1),
                      _createVNode(_component_vue_google_autocomplete, {
                        id: "address_edit",
                        class: "el-input__inner",
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.ADDRESS')}`,
                        modelValue: _ctx.address.address_1,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.address.address_1 = $event)),
                        ref: "address_1Ref",
                        value: _ctx.address.address_1,
                        onPlacechanged: _ctx.setPlace_1,
                        name: "address_edit"
                      }, null, 8, ["placeholder", "modelValue", "value", "onPlacechanged"])
                    ]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('message.ADDRESS')) + " 2 ", 1),
                      _createVNode(_component_vue_google_autocomplete, {
                        id: "address_edit1",
                        class: "el-input__inner",
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.ADDRESS')}`,
                        modelValue: _ctx.address.address_2,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.address.address_2 = $event)),
                        ref: "address_2Ref",
                        value: _ctx.address.address_2,
                        onPlacechanged: _ctx.setPlace_2,
                        name: "address_edit1"
                      }, null, 8, ["placeholder", "modelValue", "value", "onPlacechanged"])
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "city",
                        label: _ctx.$t('message.CITY'),
                        required: true,
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.CITY')}`,
                        requiredMsg: `${_ctx.$t('message.CITY')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        city: _ctx.address.city,
                        "onUpdate:city": _cache[7] || (_cache[7] = ($event: any) => (_ctx.address.city = $event)),
                        target: "city",
                        value: _ctx.address.city
                      }, null, 8, ["label", "placeholder", "requiredMsg", "city", "value"])
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_Input, {
                        type: "text",
                        name: "postal_code",
                        label: _ctx.$t('message.POSTAL_CODE'),
                        required: true,
                        placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.POSTAL_CODE')}`,
                        requiredMsg: `${_ctx.$t('message.POSTAL_CODE')} ${_ctx.$t('message.IS_REQUIRED')}`,
                        postal_code: _ctx.address.postal_code,
                        "onUpdate:postal_code": _cache[8] || (_cache[8] = ($event: any) => (_ctx.address.postal_code = $event)),
                        target: "postal_code",
                        value: _ctx.address.postal_code
                      }, null, 8, ["label", "placeholder", "requiredMsg", "postal_code", "value"])
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_Select, {
                        name: "warehouse_id",
                        target: "warehouse_id",
                        label: _ctx.$t('message.STOCK_LOCATION'),
                        filterable: true,
                        clearable: true,
                        placeholder: _ctx.$t('message.SELECT_WAREHOUSE'),
                        warehouse_id: _ctx.address.warehouse_id,
                        "onUpdate:warehouse_id": _cache[9] || (_cache[9] = ($event: any) => (_ctx.address.warehouse_id = $event)),
                        selectData: _ctx.warehouses,
                        value: _ctx.address.warehouse_id
                      }, null, 8, ["label", "placeholder", "warehouse_id", "selectData", "value"]),
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('message.ADDRESS_WAREHOUSE_DEFAULT_HINT')), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('message.DEFAULT_PAYMENT_ADDRESS')), 1),
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('message.SET_DEFAULT_PAYMENT_ADDRESS_FOR_ORDER')), 1)
                    ]),
                    _createVNode("span", _hoisted_26, [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.address.default_payment,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.address.default_payment = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('message.DEFAULT_SHIPPING_ADDRESS')), 1),
                        _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('message.SET_DEFAULT_SHIPPING_ADDRESS_FOR_ORDER')), 1)
                      ]),
                      _createVNode("span", _hoisted_32, [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.address.default_shipping,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.address.default_shipping = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_33, [
                _createVNode("button", _hoisted_34, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-custom",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handlerSubmitForm()))
                }, [
                  _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ], 64))
}